import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>経営者が押さえておくべきAI駆動開発ハンドブック</>,
  alt: '経営者が押さえておくべきAI駆動開発ハンドブック',
  readText: (
    <>
      人材不足やコスト課題を解決し、スピード・品質・持続性を高めるAI駆動開発の全体像とポイントを解説。AIと人で分担する時代へ
    </>
  ),
  imgLarge: '/images/img/download/ai-driven-development/thumbnail_ai_driven_development.webp',
  imgCapture: '/images/img/download/ai-driven-development/capture_ai_driven_development.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      AIや生成AIを活用した最新の開発スタイルに関心のある経営層や事業責任者、DX推進を担う情報システム部門の方に向けた資料です。従来の開発プロセスの課題を解消し、スピード・品質・コスト・持続性を同時に高めたいとお考えの皆様にぜひご覧いただきたい内容となっています。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '人を増やしても解決しない開発課題を、AI分業で根本から解消する方法',
  secondHalf2: '「工数削減」で測ると見誤る、AI投資の正しいROI評価軸',
  secondHalf3: 'AI生成コードをそのまま使うリスクと、統制を仕組み化する方法',
  secondHalf4: 'AI導入で変わるエンジニアの役割と、現場の抵抗を防ぐ組織設計',
  secondHalf5: '8項目で自社の準備状況がわかる、AI導入判断チェックシート付き',
}

const DownloadAIDrivenDevelopment: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'ddfbdc6c-67c2-4471-801e-37de5052ac31', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadAIDrivenDevelopment
